export default __webpack_public_path__ + "static/media/rectangle-2.206a0495.png";